.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 44px;
  padding: 0 20px;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: -0.005em;
  border: 1px solid transparent;
  border-radius: 0;
  cursor: pointer;
  transition:
    background-color var(--dur-fast) var(--ease-out),
    color var(--dur-fast) var(--ease-out),
    border-color var(--dur-fast) var(--ease-out);
}

.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.primary {
  background: var(--accent);
  color: var(--accent-foreground);
}

.primary:hover:not(:disabled) {
  background: var(--accent-hover);
}

.secondary {
  background: transparent;
  border-color: var(--border-primary);
  color: var(--text-primary);
}

.secondary:hover:not(:disabled) {
  border-color: var(--text-secondary);
}
